import {useNavigate} from 'react-router-dom';
import {OnboardingLayout} from './OnboardingLayout';
import {startGoogleSignIn} from '@/services/google';
import {useUserStore} from '@/store';
import {Button} from '@/components';
import styles from './Onboarding.module.css';

export function Welcome() {
  const navigate = useNavigate();
  const isAuthenticated = useUserStore((s) => s.isAuthenticated);

  function handleGetStarted() {
    if (isAuthenticated) {
      // Already signed in (e.g. session restored) — skip to categories
      navigate('/onboarding/categories');
    } else {
      // Redirect to Google OAuth for sign-in
      startGoogleSignIn();
    }
  }

  return (
    <OnboardingLayout currentStep={1} totalSteps={4}>
      <h2 className={styles.stepTitle}>Welcome to Closai</h2>
      <p className={styles.stepDescription}>
        We'll import your purchases automatically from email. Everything you've
        bought from the past 5 years — instantly.
      </p>
      <Button onClick={handleGetStarted}>
        {isAuthenticated ? 'Continue' : 'Sign in with Google'}
      </Button>
      {!isAuthenticated && (
        <button
          className={styles.skipLink}
          onClick={() => navigate('/onboarding/categories')}
        >
          Continue without account
        </button>
      )}
    </OnboardingLayout>
  );
}
